import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=900dd834&scoped=true&"
import script from "./Commercial.vue?vue&type=script&lang=js&"
export * from "./Commercial.vue?vue&type=script&lang=js&"
import style0 from "./Commercial.vue?vue&type=style&index=0&id=900dd834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900dd834",
  null
  
)

export default component.exports